import controller from "./passwordSignUp.controller";
import template from "./passwordSignUp.template.html";

const component = {
  restrict: "E",
  template,
  controller,
  bindings: {},
};

export default component;
